import React, { useState } from "react";
import { Form } from "react-bootstrap";
import "./textInputField.css"
const TextInputField = ({
    label,
    name,
    required,
    value = '',
    type,
    onChange,
    placeholder,
    feedbackMessage,
    colSize,
    validated,
    validationRegex,
    validationErrorMessage,
    maxLength,
    textType,
    disabled,
    mt4,
    onFocus,
    onBlur,
    onKeyDown,
    rows
}) => {
    const [error, setError] = useState(null);
    const handleInputChange = (event) => {
        let inputValue = event.target.value;
        if (maxLength && inputValue.length > maxLength) {
            inputValue = inputValue.substring(0, maxLength);
        }
        const isValidInput = validationRegex.test(inputValue);

        if (isValidInput) {
            setError(null);
            onChange({ target: { name, value: inputValue } });
        } else {
            setError(
                validationErrorMessage
            );
        }
    };

    const isTextarea = textType === "textarea";

    return (
        <Form.Group>
            {label && <Form.Label className="label-style">{label}</Form.Label>}
            <Form.Control
                name={name}
                className="password_input_field"
                required={required}
                placeholder={placeholder}
                value={value}
                type={isTextarea ? undefined : type}
                as={isTextarea ? "textarea" : undefined}
                rows={isTextarea ? rows || 3 : undefined}
                disabled={disabled}
                onChange={handleInputChange}
                maxLength={maxLength}
                isInvalid={!!error}
                onFocus={onFocus}
                onBlur={onBlur}
                onKeyDown={onKeyDown}
            />

            <Form.Control.Feedback type="invalid" className="error-message">
                {error ||
                    (validated && !validationRegex.test(value) && error)
                    ||
                    (validated && value.length <= 0 && feedbackMessage)
                }
            </Form.Control.Feedback>
        </Form.Group>
    );
};

export default TextInputField;